import React from 'react'
import { InputView } from './InputView'
import { useInput } from './useInput'

interface IInputProps {
  value?: string | number
  label?: string
  isFixed?: boolean | false
  type?: string | 'text'
  reference?: React.MutableRefObject<object>
  disabled?: boolean | false
  isFocus?: boolean | false
  isDashed?: boolean | false
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  isChecked?: boolean | false
  isMultiple?: boolean | false
  maxNumber?: number
  minNumber?: number
  stepNumber?: number
}
export type InputProps = IInputProps

export const Input = (props: InputProps): JSX.Element => {
  return (<InputView {...useInput(props)} />)
}
